import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createRef, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { CART_URLS } from '../../cart/constants';
import { DT, POST_HEADERS } from '../../../config/constants';
import { fetchError } from '../../cart/utils';
import { TEXT } from '../../../config/constants';
import { trackAddToCart } from '../../../utils/cart/addTracker';
import Assets from '../Assets';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Button from '../../../components/Button';
import css from './GiftCard.module.scss';
import Select from '../../../components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var soldOutText = TEXT.inventory.soldOut;

var GiftCard = function GiftCard(_ref) {
  var breadcrumbsList = _ref.breadcrumbsList,
      description = _ref.description,
      images = _ref.images,
      title = _ref.title,
      digital = _ref.digital,
      initialVariant = _ref.variant,
      variants = _ref.variants;
  var formRef = /*#__PURE__*/createRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var _useState3 = useState(initialVariant),
      _useState4 = _slicedToArray(_useState3, 2),
      variant = _useState4[0],
      setVariant = _useState4[1];

  var soldOut = !(variant !== null && variant !== void 0 && variant.available);
  var buttonText = soldOut ? soldOutText : TEXT.addToBag;
  var disabled = submitting || soldOut;
  var variantId = variant === null || variant === void 0 ? void 0 : variant.id;
  var assets = images.map(function (image, index) {
    return {
      id: "GiftCard-asset-".concat(index),
      image: _objectSpread({
        id: "GiftCard-image-".concat(index)
      }, image)
    };
  });

  var onAdd = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var body, errorType, request;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              setSubmitting(true);
              trackAddToCart({
                variantId: variant.id,
                title: title,
                price: variant.price
              });
              body = {
                id: variant.id,
                quantity: 1
              };
              errorType = 'adding';
              _context.prev = 5;
              _context.next = 8;
              return fetch(CART_URLS.ADD, _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
                body: JSON.stringify(body),
                credentials: 'same-origin'
              }));

            case 8:
              request = _context.sent;
              _context.next = 11;
              return request.json();

            case 11:
              window.location.assign('/cart');
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](5);
              console.error(_context.t0);
              fetchError(errorType, _context.t0);

            case 18:
              setSubmitting(false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 14]]);
    }));

    return function onAdd(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onHistoryChange = function onHistoryChange() {
    var _window = window,
        history = _window.history,
        location = _window.location;
    var urlParams = new URLSearchParams(location.search);
    urlParams.set('amount', variant.price);
    urlParams.set('variant', variant.id);
    history.replaceState({}, '', "".concat(location.pathname, "?").concat(urlParams.toString()));
  };

  var onVariantChange = function onVariantChange(event) {
    var value = event.target.value;
    var newVariantId = parseInt(value, 10);
    var newVariant = variants.find(function (v) {
      return v.id === newVariantId;
    });
    setVariant(newVariant);
  };

  useEffect(onHistoryChange, [variant, variants]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      pageTitle: title,
      breadcrumbsList: breadcrumbsList
    }), /*#__PURE__*/_jsxs("div", {
      className: css.root,
      children: [/*#__PURE__*/_jsx(Assets, {
        assets: assets,
        description: description,
        subtitle: /*#__PURE__*/_jsx("em", {
          children: "*Excluded from Discounts and Promotions."
        }),
        title: title
      }), /*#__PURE__*/_jsxs("div", {
        className: css.details,
        children: [/*#__PURE__*/_jsx("h1", {
          className: css.title,
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: css.description,
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), false && /*#__PURE__*/_jsxs("div", {
          className: css.row,
          children: [/*#__PURE__*/_jsx("p", {
            className: css.switchTitle,
            children: "What would you like?"
          }), /*#__PURE__*/_jsxs("a", {
            href: "/products/digital-gift-certificate?amount=".concat(variant.price),
            className: css.switchLabel,
            children: [/*#__PURE__*/_jsx("div", {
              "aria-hidden": "true",
              className: cc([css.switchRadio, _defineProperty({}, css.checked, digital)])
            }), "Digital \u2014 email it to me, I\u2019ll forward it along"]
          }), /*#__PURE__*/_jsxs("a", {
            href: "/products/physical-gift-certificate?amount=".concat(variant.price),
            className: css.switchLabel,
            children: [/*#__PURE__*/_jsx("div", {
              "aria-hidden": "true",
              className: cc([css.switchRadio, _defineProperty({}, css.checked, !digital)])
            }), "Physical \u2014 ship it to the address I enter at checkout"]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.row, css.last]),
          children: /*#__PURE__*/_jsx(Select, {
            buttonProps: {
              bordered: true,
              white: true
            },
            name: "amount-select",
            label: "Amount:",
            hideLabel: false,
            onChange: onVariantChange,
            value: variantId,
            options: variants.map(function (v) {
              return {
                value: v.id,
                label: v.option1
              };
            }),
            title: "Select Gift Card Amount"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "aria-label": "Add ".concat(title, " to your bag. Redirects to cart page."),
          big: true,
          className: "Rise-add-to-cart-button",
          "data-ov-event": "add-to-bag",
          disabled: disabled,
          full: true,
          onClick: onAdd,
          title: TEXT.addToBag,
          children: submitting ? DT : buttonText
        }), /*#__PURE__*/_jsxs("form", {
          method: "post",
          action: "/cart/add",
          className: "product__form",
          ref: formRef,
          children: [/*#__PURE__*/_jsx("input", {
            "aria-hidden": "true",
            type: "hidden",
            name: "id",
            value: variantId
          }), /*#__PURE__*/_jsx("input", {
            "aria-hidden": "true",
            type: "hidden",
            name: "quantity",
            value: "1"
          })]
        })]
      })]
    })]
  });
};

GiftCard.propTypes = {
  breadcrumbsList: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string
  })),
  description: PropTypes.string.isRequired,
  digital: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  title: PropTypes.string.isRequired,
  variants: PropTypes.arrayOf(PropTypes.shape({
    available: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    option1: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired
  })).isRequired,
  variant: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired
  }).isRequired
};
export default GiftCard;